"use client";

import React from "react";
import { Button } from "react-bootstrap";
import Link from "next/link";
import { FaArrowRight } from "react-icons/fa";

interface ManagedServiceProps {
  serviceName: string;
}

// Extract YouTube video ID from the embed URL
const extractYouTubeID = (url: string) => {
  const match = url.match(/embed\/([^?]+)/);
  return match ? match[1] : "";
};

const HostingVideoSection: React.FC<ManagedServiceProps> = ({ serviceName }) => {
  const serviceContent: Record<
  string,
  { title: string; subtitle: string; points: string[]; videoUrl: string }
> = {
  "Linux Reseller Hosting USA": {
    title: "Empower Your Hosting Business with Linux Reseller Hosting from the USA",
    subtitle: "Experience Speed, Flexibility, and Reliability for Your Reseller Ventures",
    points: [
      "✓ Robust Hosting Infrastructure for Seamless Reseller Success in the  ",
      "✓ Easy-to-Use WHM/cPanel for Effortless Account Management",
      "✓ 24/7 Expert Support, Your Partner in Reseller Hosting Excellence from the  .",
    ],
    videoUrl: "https://www.youtube.com/embed/Xg0-Xf0CoyE?si=Cj9dqQbHC_BS65pU",
  },
  "Linux Reseller Hosting Netherlands": {
    title: "Elevate Your Reseller Hosting Business with Linux Reseller Hosting from the Netherlands",
    subtitle: "Experience Speed, Versatility, and Reliability for Your Reseller Ventures",
    points: [
      "✓ Robust Hosting Infrastructure for Seamless Reseller Success in the Netherlands",
      "✓ User-Friendly WHM/cPanel for Effortless Account Management",
      "✓ 24/7 Expert Support, Your Partner in Reseller Hosting Excellence from the Netherlands.", 
    ],
    videoUrl: "https://www.youtube.com/embed/Xg0-Xf0CoyE?si=Cj9dqQbHC_BS65pU",
  },
  "Linux Shared Hosting": {
    title: "Unlock Your Web Potential with Linux Shared Hosting from the  ",
    subtitle: "Experience Blazing Speed, Reliability, and Support for Your Online Ventures",
    points: [
      "✓ Lightning-Fast Hosting Infrastructure for Optimal Website Performance",
      "✓ 99.9% Uptime Guarantee to Keep Your Online Presence Always On",
      "✓ 24/7 Expert Support, Your Partner in Web Hosting Success from the  .",
    ],
    videoUrl: "https://www.youtube.com/embed/Xg0-Xf0CoyE?si=Cj9dqQbHC_BS65pU",
  },
  "Windows Shared Hosting USA": {
    title: "Supercharge Your Website with Windows Shared Hosting from the USA",
    subtitle: "Experience Lightning-Fast Speed, Security, and Support for Your Online Projects",
    points: [
      "✓ Blazing Windows Hosting Infrastructure for Optimal Website Performance in the USA",
      "✓ Plesk Control Panel for Effortless Website Management",
      "✓ 24/7 Expert Support, Your Partner in Web Hosting Success from the USA.",
    ],
    videoUrl: "https://www.youtube.com/embed/Xg0-Xf0CoyE?si=Cj9dqQbHC_BS65pU",
  },
  "Windows Shared Hosting Netherlands": {
    title: "Bare Metal Dedicated Servers",
    subtitle: "The configuration you need, ready when you are.",
    points: [ 
      "✓ No long term contracts, pay for only what you use",
      "✓ Spin up Bare Metal Cloud servers and networks programmatically",
      "✓ Bootstrap any application in seconds with cloud-init and post install scripts",
    ],
    videoUrl: "https://www.youtube.com/embed/Xg0-Xf0CoyE?si=Cj9dqQbHC_BS65pU",
  },
  "Windows Reseller Hosting": {
    title: "Empower Your Hosting Business with Windows Reseller Hosting from the  ",
    subtitle: "Experience Speed, Flexibility, and Reliability for Your Reseller Ventures",
    points: [
      "✓ Robust Windows Hosting Infrastructure for Seamless Reseller Success in the  ",
      "✓ User-Friendly Plesk Control Panel for Effortless Account Management",
      "✓ 24/7 Expert Support, Your Partner in Reseller Hosting Excellence from the  .",
    ],
    videoUrl: "https://www.youtube.com/embed/Xg0-Xf0CoyE?si=Cj9dqQbHC_BS65pU",
  },
  "Linux SEO Hosting": {
    title: "Boost Your SEO Success with Temok's Premium Linux SEO Hosting",
    subtitle: "Unlock Higher Rankings, Multiple C Class IPs, and Unmatched Hosting Performance",
    points: [
      "✓ Multiple C Class IPs for Diverse Link Building and PBN Strategies",
      "✓ Lightning-Fast Load Times and 99.9% Uptime to Enhance SEO Performance",
      "✓ SEO-Friendly cPanel and Tools to Dominate Search Engine Results.",
    ],
    videoUrl: "https://www.youtube.com/embed/Xg0-Xf0CoyE?si=Cj9dqQbHC_BS65pU",
  },
};
  const content = serviceContent[serviceName] || serviceContent["Linux Shared Hosting"];

  const videoId = extractYouTubeID(content.videoUrl);

  const link = process.env.NEXT_PUBLIC_API_BASE_URL + "/register.php";

  return (
    <div className="custMargin">
      <div className="navBg py-5">
        <div className="container my-5">
          <div className="row align-items-center">
            
            {/* LEFT CONTENT */}
            <div className="col-lg-6 col-md-12 col-12">
              <div className="slogans">
                <h3 className="textOrange fw-bold display-6 fs-2">{content.title}</h3>
                <h4 className="text-white fw-semibold fs-4">{content.subtitle}</h4>

                <ul className="list-unstyled">
                  {content.points.map((point, index) => (
                    <li className="text-white py-2" key={index}>{point}</li>
                  ))}
                </ul>

                <Link href={link}>
                  <Button className="orangeBtn fw-semibold" size="lg">
                    <span>Create Account</span> <FaArrowRight />
                  </Button>
                </Link>
              </div>
            </div>

            {/* RIGHT VIDEO */}
            <div className="col-lg-6 col-md-12 col-12">
              <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, overflow: "hidden" }}>
                <iframe
                  src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=1&modestbranding=1&rel=0`}
                  title={content.title}
                  allow="autoplay; encrypted-media"
                  frameBorder="0"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                ></iframe>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default HostingVideoSection;
